import ForgetForm from './ForgetForm'

export default ForgetForm
